<template>
  <form @submit="recibirTarima">
    <div class="form-group">
      <label for="">Tarima</label>
      <input
        class="form-control text-center"
        placeholder="Tarima"
        type="text"
        id="barra_tarima"
        v-model="barra_tarima"
        autocomplete="off"
        autofocus
      />
    </div>
    <div class="col-12" v-if="error_msg">
      <small class="form-text text-danger">
        {{ error_msg }}
      </small>
    </div>
    <button class="btn btn-block btn-success" type="submit">
      Recibir Tarima
    </button>
  </form>
</template>

<script>
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {},
  props: {
    contenedor_id: {
      type: String,
    },
  },
  data() {
    return {
      barra_tarima: "",
      error_msg: null,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    recibirTarima(e) {
      e.preventDefault();
      let self = this;
      DynamicService.postAction(
        "wms",
        "contenedor",
        self.contenedor_id,
        "recepcionar_tarima",
        {
          barra: self.barra_tarima,
        }
      )
        .then((res) => {
          Notifications.toast.success(
            "Recibir Tarima",
            "Realizado correctamente"
          );
          self.$emit("refresh");
          self.barra_tarima = "";
        })
        .catch((err) => {
          if (err.response.data.detail) {
            Notifications.alert.error(
              "Recibir Tarima",
              err.response.data.detail
            );
          }
          self.barra_tarima = "";
        });
    },
  },
};
</script>
